export default "__VITE_ASSET__rmADFI7I__"